import ListNavigator from './ListNavigator'
import './EmojiBlot'
import source from './emojis.json'
import Fuse from 'fuse.js'

class Emojis {
    constructor (quill, options = {}) {
        this.quill = quill
        this.options = options
        this.matches = []
        this.picked = null
        this.pickedIndexAt = -1
        this.range = null
        this.open = false
        this.editor = this.quill.container.querySelector('[contenteditable="true"]')
        this.container = this.options.container ? document.querySelector(this.options.container) : this.quill.container
        this.navigator = new ListNavigator()
        this.onKeydown = (event) => {
            this.navigator.bindKeys(event)
        }

        document.addEventListener('click', (event) => {
            if (!this.container.contains(event.target)) {
                this.closePicker()
            }
        })

        quill.keyboard.addBinding({ key: 13 }, () => {
            if (this.open) {
                this.pickEmoji(this.navigator.current(), true)
            }

            return this.open === false
        })

        quill.keyboard.addBinding({ key: 9 }, () => {
            if (this.open) {
                this.pickEmoji(this.navigator.current())
            }

            return this.open === false
        })

        quill.keyboard.addBinding({ key: 8 }, () => {
            if (this.picked) {
                this.closePicker()
            }

            return true
        })

        quill.keyboard.addBinding({ key: 27 }, () => {
            this.closePicker()

            return true
        })

        quill.keyboard.bindings[13].unshift(quill.keyboard.bindings[13].pop())
        quill.keyboard.bindings[9].unshift(quill.keyboard.bindings[9].pop())
        quill.keyboard.bindings[8].unshift(quill.keyboard.bindings[8].pop())
        quill.keyboard.bindings[27].unshift(quill.keyboard.bindings[27].pop())

        quill.on('text-change', this.update.bind(this))
    }

    pickEmoji (element, close = false) {
        let word = this.lastTypedWord()
        let atIndex = this.range.index - word.length
        let first = false

        if (!this.picked) {
            this.pickedIndexAt = atIndex
            first = true
        }

        this.picked = element
        this.quill.deleteText(this.pickedIndexAt, first ? word.length : 1)
        this.quill.insertEmbed(this.pickedIndexAt, 'emoji', element.dataset.shortName)

        setTimeout(() => {
            this.quill.setSelection(this.pickedIndexAt + 1)
            if (close) {
                this.closePicker()
            }
        }, 0)
    }

    update () {
        if (this.picked) {
            return
        }

        let range = this.quill.getSelection()

        if (range) {
            this.range = range
        }

        this.replaceEmojis()

        if (this.range === null) {
            return
        }

        this.checkForEmojis()
    }

    getText () {
        let delta = this.quill.getContents()

        return delta.ops.reduce((carry, operation) => {
            if (typeof operation.insert === 'string') {
                return carry + operation.insert
            }

            return carry + ' '
        }, '')
    }

    replaceEmojis () {
        let originalText = this.getText()
        let text = originalText
        let matches = text.match(/:[^:\s]*(?:::[^:\s]*)*:/gs)
        let ops = []

        if (matches) {
            // Hello :smile: Bye :raised_hands: foobar
            matches.forEach((match, matchIndex) => {
                let index = text.indexOf(match)

                if (index > 0) {
                    ops.push({ retain: index })
                }

                ops.push({ delete: match.length })
                ops.push({ insert: { emoji: match.replace(/^:+|:+$/g, '') } })

                text = text.substr(index + match.length)

                if (matchIndex === matches.length - 1) {
                    ops.push({ retain: text.length })
                }
            })
        }

        this.quill.updateContents(ops, 'silent')
    }

    checkForEmojis () {
        let word = this.lastTypedWord()

        if (word.startsWith(':') && word.length > 2) {
            this.searchEmojis(word)
        } else {
            this.closePicker()
        }
    }

    lastTypedWord () {
        let words = this.quill.getText(0, this.range.index).split(/\s/)

        return words[words.length - 1]
    }

    closePicker () {
        let element = this.container.querySelector('.emoji-picker')

        if (element) {
            this.container.removeChild(element)
        }

        this.unbindKeys()

        this.open = false
        this.picked = null
        this.pickedIndexAt = -1
    }

    openPicker () {
        this.closePicker()

        let div = document.createElement('div')
        div.className = 'emoji-picker'
        div.innerHTML = this.emojiList()

        this.container.appendChild(div)
        this.navigator.build('.emoji-picker ul')
        this.navigator.onSelected((element, picked) => {
            this.pickEmoji(element, picked)
        })

        this.bindKeys()

        this.open = true
    }

    bindKeys () {
        this.editor.addEventListener('keydown', this.onKeydown)
    }

    unbindKeys () {
        this.editor.removeEventListener('keydown', this.onKeydown)
    }

    searchEmojis (query) {
        this.matches = this.filterResults(query)

        if (this.matches.length) {
            this.openPicker()
        } else {
            this.closePicker()
        }
    }

    filterResults (query) {
        var fuse = new Fuse(source, {
            keys: ['name', 'short_names'],
            threshold: 0.3
        })

        let matches = fuse.search(query.substr(1).toLowerCase())

        return matches
    }

    emojiList () {
        let html = '<ul role="listbox">'
        let percentage = 1.9607843137254901

        this.matches.slice(0, 10).forEach((emoji, index) => {
            html += `<li class="emoji-picker__item" tabindex="-1" role="option" data-short-name="${emoji.short_name}"><span style="background-image: url('/images/emojis/sheet_apple_64_indexed_256.png');background-position: ${emoji.sheet_x * percentage}% ${emoji.sheet_y * percentage}%;background-size: 5200% 5200%;"></span>\n:${emoji.short_name}:</li>`
        })

        html += '</ul>'

        return html
    }
}

export default Emojis
